import { render, staticRenderFns } from "./TranshipmentCards.vue?vue&type=template&id=e2b18e74&scoped=true"
import script from "./TranshipmentCards.vue?vue&type=script&lang=js"
export * from "./TranshipmentCards.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentCards.vue?vue&type=style&index=0&id=e2b18e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b18e74",
  null
  
)

export default component.exports